import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2403c0dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "_page_wrap" }
const _hoisted_2 = {
  class: "_page_block_clients",
  mark: "blocktitle"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_block_title1 _priv_title",
  mark: "blocktitle"
}, " 管理集团品牌墙 ", -1))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Isotope = _resolveComponent("Isotope")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Isotope, {
        class: "_block_brand_children",
        initialize: _ctx.isoInitialize,
        activated: _ctx.windowWidth>700,
        onNewWidth: _cache[0] || (_cache[0] = newWidth=>_ctx.handleNewWidth(newWidth, 'blocktitle'))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "brand_item",
              key: index
            }, [
              _createElementVNode("img", {
                src: image,
                alt: ""
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["initialize", "activated"])
    ])
  ]))
}